import { type ReactNode, useState } from 'react';
import type { SanctionReason } from '@/types';
import {
  NotesField,
  ReasonPicker,
  SanctionActions,
  SanctionWarning,
} from './creator-sanction-parts';

type Props = {
  collectorUsername: string | undefined;
  collectorRedeemed?: boolean;
  onConfirm: (vars: { reason: SanctionReason; notes: string }) => void;
  onCancel: () => void;
  isPending: boolean;
};

const HINT = 'text-[10px] text-text-tertiary';

function HintText(): ReactNode {
  return (
    <p className={HINT}>
      Se restarán 10 creadores al precio del tramo más alto. La sanción es
      permanente.
    </p>
  );
}

export function CreatorSanctionConfirm(p: Props): ReactNode {
  const [reason, setReason] = useState<SanctionReason | ''>('');
  const [notes, setNotes] = useState('');
  const submit = (): void => {
    if (!reason) return;
    p.onConfirm({ reason, notes: notes.trim() });
  };
  return (
    <div className="space-y-sm border-t border-white/[0.06] pt-base">
      <SanctionWarning
        username={p.collectorUsername}
        redeemed={!!p.collectorRedeemed}
      />
      <ReasonPicker value={reason} onChange={setReason} />
      <NotesField value={notes} onChange={setNotes} />
      <HintText />
      <SanctionActions
        onCancel={p.onCancel}
        onConfirm={submit}
        disabled={p.isPending || !reason}
      />
    </div>
  );
}
